import styles from './items.module.scss';
import { ValueFormatterParams } from 'ag-grid-community';
import { useState } from 'react';
import { useGetRequestNewHook, useTableConfigHook } from '../../../../requestUtils';
import { booleanHeader, CreateHeaders, currencyHeader, HeaderSizeEnum, Icon, PrimaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
import ContractItemInfoDialog from '../../../contract-item-info-dialog/contract-item-info-dialog';
import { IContractItemInfos } from '../../../../_models/contract-item-infos';
import { IRelationProduct } from '../../../../_models/relation-product';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ItemsProps { }

export function Items(props: ItemsProps) {
  const { t } = useTranslation();
  const { data: contractItemInfos, isLoading }: { data: IContractItemInfos[], isLoading: boolean } = useGetRequestNewHook(`contractItemInfos`, []);
  const { data: products }: { data: IRelationProduct[] } = useGetRequestNewHook(`relationProducts`, []);
  const tableConfig = useTableConfigHook("contractItemInfos");
  const [addNimbusProduct, setAddNimbusProduct] = useState<boolean>(false);
  const [contractItemInfo, setContractItemInfo] = useState<IContractItemInfos | undefined>(undefined);

  const openAddNimbusProductDialog = () => setAddNimbusProduct(true);
  const closeAddNimbusProductDialog = () => setAddNimbusProduct(false);
  const openContractItemInfoDialog = (e: any) => setContractItemInfo(e.data);
  const closeContractItemInfoDialog = () => setContractItemInfo(undefined);

  const openContractInfoRenderer = (params: ValueFormatterParams) => (
    <PrimaryButton
      variant="outlined"
      size='small'
      onClick={() => openContractItemInfoDialog(params)}>
      {t("items.seeContractInfo")}
    </PrimaryButton>
  );

  const productRenderer = (params: ValueFormatterParams) => {
    const vismaId = params.value;
    const product = products.find(p => p.vismaItemIds?.includes(vismaId));
    return product?.productName;
  };

  const connectedItemRenderer = (params: ValueFormatterParams) => {
    if (!params.value) return null;
    return `${params.value.idOfConnected} - (${params.value.requiredQuantity})`;
  };

  const headers = CreateHeaders([
    textHeader("id", "ID", HeaderSizeEnum.MEDIUM),
    textHeader("productName", t("standard.name"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("id", t("standard.product"), HeaderSizeEnum.LARGE, { renderer: productRenderer }),
    textHeader("itemType", t("standard.type"), HeaderSizeEnum.SMALL),
    textHeader("currency", t("standard.currency"), HeaderSizeEnum.SMALL, { hide: true }),
    currencyHeader("price", t("standard.price"), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    booleanHeader("isSchoolVersion", t("standard.academicVersion"), { hide: true }),
    textHeader("nimbusProductCode", t("items.nimbusProductCode"), HeaderSizeEnum.EXTRA_LARGE, { hide: true }),
    textHeader("recurringInventoryItemId", t("standard.recurringItem"), HeaderSizeEnum.EXTRA_LARGE, { hide: true }),
    textHeader("setupInventoryItemId", t("items.setupInventoryItem"), HeaderSizeEnum.EXTRA_LARGE, { hide: true }),
    textHeader("seatsPerQuantity", t("standard.numberOfSeats"), HeaderSizeEnum.SMALL, { hide: true }),
    booleanHeader("isSupportincluded", t("items.supportIncluded"), { hide: true }),
    booleanHeader("isNimbusLicense", t("items.licensingInNimbus"), { hide: true }),
    booleanHeader("canSellNew", t("items.canBeSold"), { hide: true }),
    textHeader("connectedItem", t("items.connectedItem"), HeaderSizeEnum.EXTRA_LARGE, { hide: true, renderer: connectedItemRenderer }),
    textHeader("", "", HeaderSizeEnum.LARGE, {
      renderer: openContractInfoRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    })
  ]);

  return <>
    {/* <div className="mb-3 mb-xxl-0">
      <PrimaryButton
        variant="contained"
        onClick={openAddNimbusProductDialog}>
        <Icon className="me-1" fontSize="small">add</Icon>Legg til produkt i Nimbus
      </PrimaryButton>
    </div> */}
    <WebkuaTable
      isLoading={isLoading}
      headers={headers}
      data={contractItemInfos}
      tableConfig={tableConfig}
    />
    {/* <AddNimbusProductDialog
      open={!!addNimbusProduct}
      onClose={closeAddNimbusProductDialog}
    /> */}
    {contractItemInfo && <ContractItemInfoDialog
      open={!!contractItemInfo}
      onClose={closeContractItemInfoDialog}
      contractItemInfo={contractItemInfo}
    />}
  </>;
}

export default Items;